import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class RootRedirectGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Verificar si el usuario está autenticado utilizando el servicio AuthService
    const isAuthenticated = localStorage.getItem('dataUser') !== null;

    if (isAuthenticated) {
      this.router.navigate(['/panel']);
    } else {
      // Si el usuario no está autenticado, redirigir a la página de creación de cuenta

      this.router.navigate(['/login']);
    }

    // Retornar false para evitar que se active la ruta original
    return false;
  }
}
